import { FC, useState } from 'react';

import { useFormikContext } from 'formik';
import { Textarea } from 'ui/components/form';
import { DescriptionIcon } from 'ui/components/icon';

import { EVENT_FORM } from '../schema';

const AddDescription: FC = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { values, setFieldValue } = useFormikContext<EVENT_FORM>();

  return (
    <div className="flex py-3">
      <DescriptionIcon className="mr-4 h-5 w-5 text-content" />
      {isEditing || values.content ? (
        <Textarea
          richText
          className="rounded-[6px] border-separator-primary w-full flex-1"
          value={values.content}
          onChange={(val) => setFieldValue('content', val)}
        />
      ) : (
        <button
          type="button"
          className="hover:text-secondary text-sm"
          onClick={() => setIsEditing(true)}
        >
          Add description
        </button>
      )}
    </div>
  );
};

export default AddDescription;
